<template>
  <Card class="integration-webmegler-map">
    <template #default>
      <SelectComponent
        :key="reloadKey"
        v-model="data.id"
        label="Velg hovedoppdrag:"
        sublabel="Oppdrag er hentet fra Webmegler (du må ha tilgang til oppdraget)"
        empty-label="Velg..."
        :items="getProjects"
      />
      <UnitMap
        v-if="data.id"
        :key="reloadKey"
        v-model="data"
        :id="data.id"
        :disabled="Boolean(progress)"
        @error="error = $event"
      />
      <Alert>
        <a target="_blank" href="https://help.kvass.no/nb/articles/14530">Les mer om oppsett av integrasjon her</a>
      </Alert>
    </template>
    <template #footer>
      <Alert v-if="hasDuplicateSelection" theme="error"> Du har brukt en enhet i Kvass flere ganger. </Alert>
      <Alert v-if="progress">{{ progress }}</Alert>
      <Alert v-if="error" theme="error" class="integration-webmegler-map__error">{{ error }}</Alert>
      <ButtonComponent
        :label="error ? 'Prøv igjen' : 'Fullfør'"
        :icon="['fal', 'arrow-to-right']"
        theme="primary"
        :disabled="isDisabled"
        @click="error ? retry() : submit()"
        :promise="promise"
      />
    </template>
  </Card>
</template>

<script>
import SelectComponent from '@kvass/custom-fields/src/Fields/SelectModal'
import Card from '@kvass/card'
import { ButtonComponent } from 'vue-elder-button'
import UnitMap from '@/components/Webmegler/Map'
import { AlertComponent as Alert } from 'vue-elder-alert'
import { request, stream } from '@/api/request'

const noDupes = arr => {
  return arr.every(x => arr.filter(u => u === x).length <= 1)
}

export default {
  inject: ['account', 'token', 'integration', 'webmegler'],

  data() {
    return {
      promise: null,
      error: null,
      projects: [],
      reloadKey: 0,
      progress: null,
      data: {
        id: this.webmegler || null,
        map: {},
      },
    }
  },
  watch: {
    'data.id'() {
      this.error = null
    },
  },
  computed: {
    hasDuplicateSelection() {
      return !noDupes(Object.values(this.data.map || {}).filter(Boolean))
    },

    isDisabled() {
      if (this.progress) return true
      if (this.error && (!this.projects.length || !this.data.map)) return false
      return !this.data.id || !this.data.map || this.hasDuplicateSelection
    },
  },
  methods: {
    getProjects() {
      const query = this.data.id ? `?id=${this.data.id}` : ''

      return request(`https://${this.account}/api/integration/${this.integration}/callbacks/projects${query}`, {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })
        .then(res => res.json())
        .then(projects => (this.projects = projects))
        .catch(err => {
          this.error = err
          return (this.projects = [])
        })
    },
    retry() {
      if (!this.projects.length || !this.data.map) return this.reload()
      return this.submit()
    },
    reload() {
      this.error = null
      this.reloadKey++
    },
    submit() {
      if (this.isDisabled) return

      this.error = null
      this.progress = 'Lagrer oppkobling…'

      this.promise = stream(
        `https://${this.account}/api/integration/${this.integration}/callbacks/init`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(this.data),
        },
        message => (this.progress = message),
      )
        .then(() => this.$emit('navigate', 'completed'))
        .catch(err => {
          this.error = err
          throw err
        })
        .finally(() => (this.progress = null))
    },
  },
  components: {
    SelectComponent,
    Card,
    UnitMap,
    ButtonComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.integration-webmegler-map {
  .kvass-card__content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__error {
    white-space: pre-line;
  }
}
</style>
